import { render } from "./DealLeakRule.vue?vue&type=template&id=9dbfabd8&scoped=true"
const script = {}

import "./DealLeakRule.vue?vue&type=style&index=0&id=9dbfabd8&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dbfabd8"]])

export default __exports__